import React from "react";

const CATEGORIES = [
  {
    title: "Non-Surgical",
    items: ["Botox", "Dermal Fillers", "Profile Harmonization"],
  },
  {
    title: "Surgical",
    items: ["Facial contouring", "Body sculpting"],
  },
];

const SERVICE_CARDS = [
  {
    title: "Botox",
    category: "Non-Surgical",
    gradient: "from-slate-700 via-primary to-primary",
  },
  {
    title: "Dermal Fillers",
    category: "Non-Surgical",
    gradient: "from-primary via-slate-800 to-primary",
  },
  {
    title: "Profile Harmonization",
    category: "Non-Surgical",
    gradient: "from-slate-600 via-primary to-slate-900",
  },
  {
    title: "Facial Contouring",
    category: "Surgical",
    gradient: "from-primary via-slate-700 to-primary",
  },
  {
    title: "Body Sculpting",
    category: "Surgical",
    gradient: "from-slate-800 via-primary to-slate-900",
  },
];

export function SignatureServices({ scrollToSection }) {
  return (
    <section
      id="services"
      className="scroll-mt-28 bg-background py-section px-6 md:px-10"
    >
      <div className="mx-auto max-w-[1200px]">
        <div className="mb-12 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <h2 className="font-heading text-4xl font-semibold text-primary md:text-5xl">
              Signature Procedures
            </h2>
            <div className="mt-4 h-px w-10 bg-accent" />
          </div>
        </div>

        <div className="mb-16 grid gap-10 md:grid-cols-2">
          {CATEGORIES.map((cat) => (
            <div key={cat.title}>
              <h3 className="font-body text-xs font-medium uppercase tracking-[2px] text-accent">
                {cat.title}
              </h3>
              <ul className="mt-4 space-y-2 font-body text-base font-light text-ink">
                {cat.items.map((item) => (
                  <li key={item} className="border-b border-muted/40 pb-2">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICE_CARDS.map((card) => (
            <button
              key={card.title}
              type="button"
              onClick={() => scrollToSection("contact")}
              className="group relative aspect-[4/3] w-full overflow-hidden rounded-none border border-transparent text-left transition-all duration-300 hover:border-accent"
            >
              <div
                className={`absolute inset-0 bg-gradient-to-br ${card.gradient} transition duration-300 group-hover:grayscale-[0.35]`}
                aria-hidden
              />
              <div className="absolute inset-0 bg-primary/55 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
              <div className="absolute inset-0 flex flex-col justify-end p-6">
                <span className="font-body text-[10px] font-medium uppercase tracking-[2px] text-white/80">
                  {card.category}
                </span>
                <span className="mt-1 font-heading text-2xl text-white">
                  {card.title}
                </span>
                <span className="mt-4 font-body text-xs font-medium uppercase tracking-[2px] text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  Learn More
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
